import { WikiArticle, WikiArticleMain, WikiArticleSubPanel } from '../WikiArticle'
import { Heading, ListItem, Text } from '@chakra-ui/react'
import { LinkToSection, SectionIndex, SectionTitle } from '../../../new_component/organisms/SectionIndex'

const InterfacesIntro = () => {
	return <WikiArticle>
    <WikiArticleMain>
      <section>
        <Heading as="h2">Intro to Interfaces</Heading>
        <Text>
				Welcome to the integration hub of Application Base development!
        </Text>
				<Text>
				This section is your go-to guide for making the most of our powerful APIs and seamlessly incorporating 
				our JavaScript library into your application workflow. Whether you’re building complex enterprise tools 
				or lightweight client-facing apps, this guide will help you align frontend behavior with the flexibility 
				and power of Form Query Language (FQL).
				</Text>
        
      </section>
			
      <section>
        <SectionTitle>Why this matters</SectionTitle>
        <Text>
				FQL revolutionizes how user transactions (Forms) are modeled and executed — not just by simplifying logic 
				but by humanizing it. But the magic doesn’t stop at query syntax. By coupling FQL with API endpoints and 
				client-side capabilities via our JS library, you unlock:
        </Text>
				<Text>
						•	🔁 Real-time interaction with the Application Base
				</Text>
				<Text>
						•	🔒 Strong data integrity backed by structured access logic
				</Text>
				<Text>
						•	🧩 Smooth extension of FQL into UI layers without redundant back-end scaffolding
				</Text>

				<Text>
				In the pages ahead, you’ll find:
				</Text>
				<Text>
				•	✅ Recommended patterns for endpoint usage
				</Text>
				<Text>
				•	🧰 How to authenticate, fetch, and manipulate data via API
				</Text>
				<Text>
				•	📦 How to include and configure out JS library in your app
				</Text>
      </section>
      
    </WikiArticleMain>
    <WikiArticleSubPanel>
      <SectionIndex>
        <ListItem><LinkToSection>Why this matters</LinkToSection></ListItem>
      </SectionIndex>
    </WikiArticleSubPanel>
  </WikiArticle>
}

export default InterfacesIntro